/* eslint-disable */

/**
 * @title    - Cta Module
 * @desc     - Overall code for Cta module
 * @param    - none
 * @return   - object with public functions and/or variables
 */
Search = (function () {
    var init = function () {
        if (document.getElementsByClassName('search-autocomplete').length > 0) {
            var searchInput = document.querySelectorAll('.search-autocomplete')

            for (var i = 0; i < searchInput.length; i++) {
                var searchTarget = searchInput[i].getAttribute('data-search')
                var xhr = new XMLHttpRequest()
                xhr.open(
                    'GET',
                    window.__appData__.ajaxUrl +
                        '?action=search_' +
                        searchTarget,
                    true
                )
                xhr.send(null)

                new autoComplete({
                    selector: searchInput[i],
                    minChars: 3,
                    source: function (term, suggest) {
                        term = term.toLowerCase()
                        var data = xhr.responseText
                        var jsonResponse = JSON.parse(data)
                        var choices = jsonResponse['data']
                        var suggestions = []
                        for (i = 0; i < choices.length; i++) {
                            if (
                                ~choices[i].post_title
                                    .toLowerCase()
                                    .indexOf(term)
                            )
                                suggestions.push(choices[i])
                        }
                        suggest(suggestions)
                    },
                    renderItem: function (item, search) {
                        search = search.replace(
                            /[-\/\\^$*+?.()|[\]{}]/g,
                            '\\$&'
                        )
                        var re = new RegExp(
                            '(' + search.split(' ').join('|') + ')',
                            'gi'
                        )
                        return (
                            '<div class="autocomplete-suggestion" data-type="' +
                            item.posttype_title +
                            '" data-val="' +
                            search +
                            '" data-url="' +
                            item.post_url +
                            '">' +
                            item.post_title.replace(re, '<b>$1</b>') +
                            '</div>'
                        )
                    },
                    onSelect: function (e, term, item) {
                        var itemUrl = item.getAttribute('data-url')
                        window.location.href = itemUrl
                        e.preventDefault()
                    },
                })
            }
        }
    }

    // return public functions and/or variables to use in other modules
    return {
        init: init,
    }
})()

Search.init()



// WEBPACK FOOTER //
// ./scripts/legacy/modules/search.js